<template>
    <div class="home_component">
        <router-view></router-view>
        <Tabbar active-color="#ED761E" v-model="active" @change="activeItem" :safe-area-inset-bottom="true">
            <TabbarItem v-for="(item,index) in tabBarList" :key="item.name" :to="{name:item.name}" :name="index" replace>
                <img :src="index==active?item.iconactive:item.icon" alt="">
                <span style="padding-top: .16rem;">{{item.text}}</span>
            </TabbarItem>
        </Tabbar>
    </div>
</template>

<script>
    import './_home.less'
    import {Tabbar, TabbarItem,} from 'vant';

    export default {
        name: 'HomeL',
        watch:{
          '$route.name':function(e){
              this.activeItem(e);
          }
        },
        methods:{
          activeItem(e){
              this.tabBarList.forEach((item,index)=>{
                  if(item.name==e){
                      this.active    =   index;
                  }
              })

          }
        },
        components: {
            Tabbar,
            TabbarItem
        },
        data() {
            return {
                active: 0,
                tabBarList: [
                    {
                        name: "index",
                        icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/230917.png',
                        iconactive: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220927/1664249341/104078.png',
                        text: '活动',
                    }, 
                    // {
                    //     name: "health",
                    //     icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/568794.png',
                    //     iconactive: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/701121.png',
                    //     text: '健康课堂',
                    // }, 
                    // {
                    //     name: "exchange",
                    //     icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/666826.png',
                    //     iconactive: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/591292.png',
                    //     text: '积分乐换',
                    // }, 
                    {
                        name: "my",
                        icon: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220325/1648201820/175943.png',
                        iconactive: 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220927/1664249341/9426.png',
                        text: '个人中心',
                    }
                ]
            }
        },
        mounted() {
            this.$nextTick(()=>{
              this.activeItem(this.$route.name);
            })
        }
    }
</script>
